module.exports = __webpack_public_path__ + "static/media/analytic-forecast-trends.1faa85b4.png";